import Swal, { SweetAlertIcon } from 'sweetalert2';

export interface SwalConfirmOptions {
  title: string;
  text?: string;
  html?: string;
  icon?: SweetAlertIcon;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  cancelColor?: string;
}

export async function swalConfirm(options: SwalConfirmOptions): Promise<boolean> {
  const result = await Swal.fire({
    title: options.title,
    ...(options.html ? { html: options.html } : { text: options.text }),
    icon: options.icon ?? 'question',
    showCancelButton: true,
    confirmButtonText: options.confirmText ?? 'ยืนยัน',
    cancelButtonText: options.cancelText ?? 'ยกเลิก',
    confirmButtonColor: options.confirmColor ?? '#3b82f6',
    cancelButtonColor: options.cancelColor ?? '#6b7280',
    reverseButtons: true,
    focusCancel: true,
  });
  return result.isConfirmed;
}
